module.exports = __webpack_public_path__ + "static/media/Meghan5.e63c03a3.tif";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/spoon/Meghan5.tif
// module id = 137
// module chunks = 0